import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.m.pri,
    [
      face.u.two,
      face.m.two,
      face.u.two,
    ],
    face.m.pri,
  ],
  name: 'Columns',
};
